document.addEventListener('DOMContentLoaded', function() {
    // Mobile Menu Toggle
    const menuBtn = document.getElementById('menu-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    if (menuBtn && mobileMenu) {
        menuBtn.addEventListener('click', () => {
            mobileMenu.classList.toggle('open');
        });
    }
    
    // Close mobile menu when clicking on a link
    document.querySelectorAll('#mobile-menu a').forEach(link => {
        link.addEventListener('click', () => {
            if (mobileMenu) {
                mobileMenu.classList.remove('open');
            }
        });
    });
    
    // Back to Top Button
    const backToTopBtn = document.getElementById('back-to-top');
    if (backToTopBtn) {
        window.addEventListener('scroll', () => {
            if (window.pageYOffset > 300) {
                backToTopBtn.classList.remove('opacity-0', 'invisible');
                backToTopBtn.classList.add('opacity-100', 'visible');
            } else {
                backToTopBtn.classList.remove('opacity-100', 'visible');
                backToTopBtn.classList.add('opacity-0', 'invisible');
            }
        });
        
        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }
    
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            if (targetId === '#') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
    
    // Dynamic Video Loading
    const videos = [
        { 
            id: '9-vETNRLhlU', 
            title: 'KIA ENGINE SETTLEMENT 2023!', 
            desc: 'How to get your Kia engine replaced under recall and avoid dealership charges.' 
        },
        { 
            id: 'idja-p2yMQQ', 
            title: 'Engine Repair Walkthrough', 
            desc: 'A detailed guide to help with your engine repair process.' 
        },
        { 
            id: 'uYzGlXWYk7c', 
            title: 'NEW SCRIPT BOOK: WHAT TO SAY TO GET YOUR ENGINE REPLACED', 
            desc: 'Word-for-word scripts and email templates to help you get a free engine replacement.' 
        },
        { 
            id: 'AiNC3A4cu_k', 
            title: 'DENIED DUE TO NOT HAVING KSDS', 
            desc: 'Why Kia/Hyundai might deny engine replacements and what you can do about it.' 
        }
    ];
    
    const videoGrid = document.querySelector('#videos .grid');
    if (videoGrid) {
        videoGrid.innerHTML = videos.map(video => `
            <div class="bg-zinc-900 rounded-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300">
                <div class="video-container">
                    <iframe 
                        src="https://www.youtube.com/embed/${video.id}" 
                        title="${video.title}" 
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen>
                    </iframe>
                </div>
                <div class="p-6">
                    <h3 class="text-xl font-semibold mb-2">${video.title}</h3>
                    <p class="text-gray-400">${video.desc}</p>
                    <div class="mt-4 flex items-center text-yellow-accent">
                        <i class="fas fa-play-circle mr-2"></i>
                        <span>Watch Now</span>
                    </div>
                </div>
            </div>
        `).join('');
    }
    
    // Form submission with custom notification
    const contactForm = document.getElementById('contact-form');
    const notification = document.getElementById('notification');

    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Show notification
            notification.classList.add('show');
            
            // Hide notification after 3 seconds
            setTimeout(() => {
                notification.classList.remove('show');
            }, 3000);

            this.reset();
        });
    }

    // Testimonials Carousel
    const testimonials = [
        {
            name: 'Marcus Bennett',
            vehicle: '2017 Kia Sorento',
            review: "The script book was a game-changer. I knew exactly what to say to the dealership and they approved my engine replacement without any hassle."
        },
        {
            name: 'Elena Torres',
            vehicle: '2015 Hyundai Sonata',
            review: "I was getting the runaround from corporate until I used the email templates in the handbook. Suddenly, they were calling me to resolve the issue. Incredible."
        },
        {
            name: 'Jordan Whitaker',
            vehicle: '2018 Kia Optima',
            review: "Carl's guide on documenting oil consumption was the key to my success. The dealership couldn't argue with the evidence I presented."
        },
        {
            name: 'Priya Desai',
            vehicle: '2016 Hyundai Tucson',
            review: "I was about to give up after being denied, but the appeal process outlined in the book gave me the confidence to fight back. So glad I did!"
        },
        {
            name: 'Tyler Monroe',
            vehicle: '2014 Kia Forte',
            review: "Honestly, just having the handbook made me feel so much more in control. It's like having a master mechanic in your corner."
        },
        {
            name: 'Amara Liu',
            vehicle: '2019 Hyundai Elantra',
            review: "I saved thousands of dollars by following the DIY repair guides for a few minor issues before tackling the main engine problem. This book is a must-have."
        },
        {
            name: 'Darius King',
            vehicle: '2017 Hyundai Santa Fe',
            review: "The information in these books is priceless. I was able to get my engine replaced even though I was the second owner and out of the original warranty."
        },
        {
            name: 'Sofia Romano',
            vehicle: '2016 Kia Soul',
            review: "I'm not a car person at all, but Carl's guides are so easy to follow. I was able to diagnose the problem myself and walk into the dealership with confidence."
        },
        {
            name: 'Nolan Brooks',
            vehicle: '2015 Kia Sportage',
            review: "The best money I've ever spent on my car. The dealership took me seriously as soon as I started using the language from the script book."
        }
    ];

    const swiperWrapper = document.querySelector('#testimonials .swiper-wrapper');
    if (swiperWrapper) {
        swiperWrapper.innerHTML = testimonials.map(testimonial => `
            <div class="swiper-slide">
                <div class="testimonial-card p-6 rounded-lg h-full flex flex-col justify-between">
                    <div>
                        <div class="flex items-center mb-4">
                            <div class="flex text-yellow-accent">
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                            </div>
                        </div>
                        <p class="text-gray-300 mb-4 italic">"${testimonial.review}"</p>
                    </div>
                    <div class="flex items-center">
                        <div>
                            <h4 class="font-semibold">${testimonial.name}</h4>
                            <p class="text-gray-500 text-sm">${testimonial.vehicle} Owner</p>
                        </div>
                    </div>
                </div>
            </div>
        `).join('');

        const swiper = new Swiper('.swiper-container', {
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            slidesPerView: 1,
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            }
        });
    }
});
